const combineStyles = (...styles) => styles.filter(Boolean).join("");
export {
  combineStyles
};
//# sourceMappingURL=combineStyles.js.map
